export type StatusColor =
  | "primary"
  | "primary-light"
  | "secondary"
  | "secondary-light"
  | "success"
  | "success-light"
  | "danger"
  | "danger-light"
  | "warning"
  | "warning-light";

export const SHIFT_STATUS_COLORS: Record<
  string,
  StatusColor | Record<string, StatusColor>
> = {
  Completed: "success-light",
  Incomplete: "danger-light",
  "Checked-in": {
    Full: "secondary-light",
    Partial: "warning-light",
    None: "danger-light",
  },
  Registered: {
    Full: "primary-light",
    Partial: "warning-light",
    None: "danger-light",
  },
};

export const SHIFT_CATEGORIES = [
  "Activities",
  "Workshops",
  "Food",
  "Ceremonies",
  "Floor Patrol",
  "Security",
  "Supplementary",
];

export const PRIMARY_SHIFTS = [
  "Activities",
  "Workshops",
  "Food",
  "Ceremonies",
  "Floor Patrol",
  "Security",
];
